import styled from 'styled-components';
import { colorCSS, radius } from '../../styles';
export const Block = styled.div `
  overflow: hidden;
  ${({ appearance }) => appearance != 'No Padding' && 'padding: 1.5rem 3rem;'}  
  ${({ fullHeight }) => fullHeight && 'height: 100%;'}  

  ${({ appearance }) => appearance == 'Top Blue Stripe'
    ? `
      padding-top: 3rem;
      position: relative;
      &:before {
        background: linear-gradient(
          135deg,
          ${colorCSS('P300')} 0%,
          ${colorCSS('B300')} 50%,
          ${colorCSS('T300')} 100%
        );
        content: '';
        height: 1.5rem;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }`
    : appearance == 'Neutral Border'
        ? `border: 1px solid ${colorCSS('N60')};`
        : null}
  ${({ background }) => background && `background: ${background};`}
  ${({ color }) => color && `color: ${color};`}
  ${({ roundedCorners }) => roundedCorners && `border-radius: ${radius[roundedCorners.toLowerCase()]};`}
  ${({ shadow }) => shadow && `box-shadow: 0 0 1rem ${colorCSS('N900', 0.25)};`}

  > * { flex-grow: 1; }
  *:last-child { margin-bottom: 0; }
`;
//# sourceMappingURL=UiBlock.styled.js.map